import {
    ProductsEnum,
    resourcesHelper
} from "@falcon/services";
import * as React from "react";
import {Link} from "react-router-dom";
import {getAmountToDisplay} from "../../CommonFunctions";

interface IProps {
    amount?: number;
    multiProductPage?: boolean;
    policyNumber: string;
    product: ProductsEnum;
    propertyName?: string;
    // Map of invoice id and amount
    unpaidInstallmentIdToAmount: any;
    ncdImpactedClaim?: boolean;
    isDirectDebit?: boolean;
    reuseCard?: boolean;
}

export class OverdueInstalmentBanner extends React.Component<IProps> {


    constructor(props: any) {
        super(props);
        this.state = {}
    }

    public render(): React.ReactNode {
        const paymentPage: string = this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment";
        const unpaidInvoiceIds = Array.from(Object.keys(this.props.unpaidInstallmentIdToAmount));
        if (unpaidInvoiceIds.length === 2) {
            return (
                <div className="inner-cogntainer">
                    <div className="warning-banner dashboard-missed-payment-banner mb-0">
                        <div className="w-100">
                            <div className="overflow-auto">
                                <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon"
                                     className="inline-warning-icon pt-2"/>
                                <div className="banner-text inline-warning-text">
                                    Your last 2 instalments are overdue and they must be paid separately:
                                    <div>
                                        <Link id="payNow"
                                              className="d-inline text-decoration-underline cursor-pointer muli-bold-16"
                                              aria-label={"Pay Now"}
                                              state={{
                                                  verifyCardFailed: false,
                                                  product: this.props.product
                                              }}
                                              to={`/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`}>
                                            {'Pay ' + getAmountToDisplay(this.props.unpaidInstallmentIdToAmount[unpaidInvoiceIds[0]]) + ' now '}</Link>
                                        for your 1st missed payment
                                    </div>
                                    <div>
                                        <span id="payNow"
                                              className="d-inline text-decoration-underline cursor-pointer grey-link muli-bold-16 grey-link"
                                              aria-label={"Pay Now"}>
                                            {'Pay ' + getAmountToDisplay(this.props.unpaidInstallmentIdToAmount[unpaidInvoiceIds[1]]) + ' now '}</span>{' '}for your 2nd missed payment
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else if (this.props.ncdImpactedClaim && !this.props.isDirectDebit) {
            return (
                <div className="inner-container">
                    <div className="banner dashboard-missed-payment-banner">
                        <div className="w-100">
                            <div className="overflow-auto d-flex">
                                <div className="float-left">
                                    <img src="/img/warning-filled.svg" alt="Orange warning icon" className="inline-warning-icon"/>
                                </div>
                                <div className="banner-text inline-warning-text">
                                    Your last instalment of <span className="font-weight-bold">{getAmountToDisplay(this.props.amount)} </span>is overdue.
                                    If you don’t pay the outstanding premium we may pass it to a debt collection agency and this may impact your credit rating.
                                </div>
                            </div>
                            <div className="my-3">
                                <Link id="payNow" className="text-decoration-underline muli-bold-16"
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={`/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`}>
                                    Pay {getAmountToDisplay(this.props.amount)} now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (this.props.multiProductPage) {

            return (
                <div className="inner-container">
                    <div className="warning-banner dashboard-missed-payment-banner mb-0">
                        <div className="w-100">
                            <div className="overflow-auto">
                                <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon" className="inline-warning-icon pt-2"/>
                                <div className="banner-text inline-warning-text">
                                    Your last instalment of <span className="font-weight-bold">{getAmountToDisplay(this.props.amount)} </span>
                                    for your {this.props.propertyName || 'policy'} is overdue.
                                    Missing instalment payments can lead to your {this.props.product === ProductsEnum.HOME ? "" : "car "}policy being cancelled.

                                    <div className="link-container">
                                        <Link id="payNow" className="text-decoration-underline cursor-pointer muli-bold-16" aria-label={"Pay Now"}
                                              state={{
                                                  verifyCardFailed: false,
                                                  product: this.props.product
                                              }}
                                              to={`/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`}>
                                        Pay the balance now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="inner-container">
                    <div className="banner dashboard-missed-payment-banner">
                        <div className="w-100">
                            <div className="overflow-auto d-flex">
                                <div className="float-left">
                                    <img src="/img/warning-filled.svg" alt="Orange warning icon" className="inline-warning-icon"/>
                                </div>
                                <div className="banner-text inline-warning-text">
                                    Your last instalment of <span className="font-weight-bold">{getAmountToDisplay(this.props.amount)} </span>is overdue.
                                    Missing instalment payments can lead to your {this.props.product === ProductsEnum.HOME ? "" : "car "}policy being cancelled.
                                </div>
                            </div>
                            <div className="my-3">
                                <Link id="payNow" className="text-decoration-underline muli-bold-16"
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={`/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`}>
                                    Pay {getAmountToDisplay(this.props.amount)} now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
